import React from "react";
import EmployeeContainer from "./components/EmployeeContainer";
import Header from "./components/Header";
function App() {
  return(
  <>
  <Header/>
  <EmployeeContainer />
  </>
  )
};

export default App;
